import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Label = ({ label, name, required, hideLabel }) => {
  const labelClasses = classNames('uni-form__label', {
    'u-sr-only': hideLabel,
  });

  return (
    <label className={labelClasses} htmlFor={name} hidden={hideLabel}>
      {label}
      {required ? <span className="uni-form__required" /> : null}
    </label>
  );
};

Label.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  hideLabel: PropTypes.bool,
};

Label.defaultProps = {
  required: false,
  hideLabel: false,
};

export default Label;



// WEBPACK FOOTER //
// ./src/forms/__partials/label.jsx